import React, { createContext, Fragment, useState } from 'react'
import PropTypes from 'prop-types'
import DashboardPage from '../containers/Dashboard/DashboardPage'
import ProfilePage from '../containers/Dashboard/ProfilePage'
import Rewards from '../containers/Dashboard/Rewards/RewardsContent'
import Missions from '../containers/Dashboard/Missions/MissionsContent'
import Influencer from '../containers/Dashboard/Influencer'
import ReferralLog from '../containers/Dashboard/ReferralLog'
import ShareEarn from '../containers/Dashboard/ShareEarn'
import { getFromLocalStorage } from '../helper/storage'
import i18n from 'i18n'
import { Redirect, Route } from 'react-router-dom'
import langUrl from '../../CampaignSystem/utils/langUrl'

export const JazeelContext = createContext()

export function JazeelProvider(props) {
  const [userData, setUserData] = useState(
    getFromLocalStorage('userData:') || null,
  )
  const [brandData, setBrandData] = useState(
    getFromLocalStorage('brandData:') || null,
  )
  const [auth, setAuth] = useState(getFromLocalStorage('auth:') || false)
  const [loginError, setLoginError] = useState(null)
  const [signupError, setSignupError] = useState(null)
  const [signupSuccess, setSignupSuccess] = useState(null)
  const [events, setEvents] = useState(null)
  const [login, setLogin] = useState(true)

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767)
  const [isSmallMobile, setIsSmallMobile] = useState(window.innerWidth <= 576)
  window.addEventListener('resize', () =>
    window.innerWidth <= 767 ? setIsMobile(true) : setIsMobile(false),
  )
  window.addEventListener('resize', () =>
    window.innerWidth <= 576 ? setIsSmallMobile(true) : setIsSmallMobile(false),
  )
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

  // console.log('isMobile: ', isMobile)
  // console.log('userData:', userData)
  // console.log('auth:', auth)
  // console.log('success:', signupSuccess)
  // console.log('authError:', loginError)
  const pages = [
    {
      name: i18n.t('routes.home'),
      path: getFromLocalStorage('brandData:')
        ? `/${langUrl}/brand/dashboard`
        : getFromLocalStorage('userData:')
        ? `/${langUrl}/influencer/dashboard`
        : `/${langUrl}`,
      controls: 'v-pills-profile',
      component: DashboardPage,
    },
    // {
    //   name: 'Missions',
    //   path: '/dashboard/missions',
    //   controls: '',
    //   component: Missions,
    // },
    // {
    //   name: 'Rewards',
    //   path: '/dashboard/prizes',
    //   controls: '',
    //   component: Rewards,
    // },
    // {
    //   name: 'Share and Earn',
    //   path: '/dashboard/share-earn',
    //   controls: '',
    //   component: ShareEarn,
    // },
    // {
    //   name: 'Referral Log',
    //   path: '/dashboard/transaction-history',
    //   controls: '',
    //   component: ReferralLog,
    // },
    // {
    //   name: 'Influencer',
    //   path: '/dashboard/influencer',
    //   controls: '',
    //   component: Influencer,
    // },
    // {
    //   name: 'My Profile',
    //   path: '/dashboard/profile',
    //   controls: 'v-pills-home',
    //   component: ProfilePage,
    // },
  ]

  return (
    <JazeelContext.Provider
      value={{
        pages,
        userData,
        setUserData,
        brandData,
        setBrandData,
        auth,
        setAuth,
        loginError,
        setLoginError,
        signupError,
        setSignupError,
        signupSuccess,
        setSignupSuccess,
        events,
        setEvents,
        login,
        setLogin,
        isMobile,
        mobileMenuOpen,
        setMobileMenuOpen,
        isSmallMobile,
      }}
    >
      {props.children}
    </JazeelContext.Provider>
  )
}

JazeelProvider.propTypes = {
  children: PropTypes.object,
}
